import React, { useEffect, useState } from "react";

const NavbarMessageSlider = ({ monthlyMessage, annualMessage }) => {
  const messages = [monthlyMessage, annualMessage].filter(Boolean);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    // If only one message → continuous scroll, no switching
    if (messages.length <= 1) {
      setAnimate(true);
      return;
    }

    let timeout1, timeout2;

    const runAnimation = () => {
      setAnimate(true);

      // Scroll duration
      timeout1 = setTimeout(() => {
        setAnimate(false);

        // Small pause before next message
        timeout2 = setTimeout(() => {
          setCurrentIndex((prev) => (prev + 1) % messages.length);
          runAnimation();
        }, 1000); // 1s pause
      }, 20000); // 20s scroll
    };

    runAnimation();

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, [messages.length]);

  if (!messages.length) return null;

  return (
    <div
      style={{
        width: "50%",
        background: "red",
        overflow: "hidden",
        padding: "8px 0",
        borderRadius: "6px",
      }}
    >
      <div
        key={currentIndex}
        style={{
          fontWeight: "bold",
          fontSize: "large",
          color: "yellow",
          display: "inline-block",
          whiteSpace: "nowrap",
          paddingLeft: "100%",
          animation:
            messages.length > 1
              ? animate
                ? "scroll 20s linear"
                : "none"
              : "scroll 20s linear infinite", // continuous if only one
        }}
      >
        {messages[currentIndex]}
      </div>

      <style>
        {`
          @keyframes scroll {
            from {
              transform: translateX(0%);
            }
            to {
              transform: translateX(-100%);
            }
          }
        `}
      </style>
    </div>
  );
};

export default NavbarMessageSlider;
